import { CreateTimeoffRuleRequestType } from "../../../types/request/timeoff";

export type AccrualSetupStepProps = { 
    formData: CreateTimeoffRuleRequestType;
}

const SummaryStep = ({ formData }: AccrualSetupStepProps) => {
    return (
        <div className="bg-white p-6 rounded-lg border border-gray-200">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Time-off Policy Summary</h2>

            {/* General Policy Information */}
            <div className="mb-6">
                <h3 className="text-lg font-medium text-gray-700 border-b pb-2 mb-3">General Information</h3>
                <div className="grid grid-cols-2 gap-4 text-gray-600">
                    <p><strong>Policy Code:</strong> {formData.policy_code || "N/A"}</p>
                    <p><strong>Category Code:</strong> {formData.category_code || "N/A"}</p>
                    <p><strong>Policy Type:</strong> {formData.policy_type || "N/A"}</p>
                    <p><strong>Accrual Rate:</strong> {formData.accrual_rate ?? "N/A"} hrs</p>
                    <p><strong>Accrual Period:</strong> {formData.accrual_period || "N/A"}</p>
                    <p><strong>Waiting Period:</strong> {formData.has_waiting_period ? "Yes" : "No"}</p>
                </div>
            </div>

            {/* Accrual Setup */}
            <div className="mb-6">
                <h3 className="text-lg font-medium text-gray-700 border-b pb-2 mb-3">Accrual Setup</h3>
                <div className="grid grid-cols-2 gap-4 text-gray-600">
                    <p><strong>Cap Enabled:</strong> {formData.cap_enabled ? "Yes" : "No"}</p>
                    {formData.cap_enabled && (
                        <p><strong>Cap Hours Limit:</strong> {formData.cap_hours_limit ?? "N/A"} hrs</p>
                    )}
                </div>
            </div>

            {/* Carryover Rules */}
            {formData.carryover_enabled && formData.carryover_json && (
                <div className="mb-6">
                    <h3 className="text-lg font-medium text-gray-700 border-b pb-2 mb-3">Carryover Rules</h3>
                    <div className="grid grid-cols-2 gap-4 text-gray-600">
                        <p><strong>Rule:</strong> {formData.carryover_json.rule || "N/A"}</p>
                        <p><strong>Hours:</strong> {formData.carryover_json.hours ?? "N/A"}</p>
                        <p><strong>Carryover Date:</strong> {formData.carryover_json.carryover_date || "N/A"}</p>
                        <p><strong>Reset Negative Balance:</strong> {formData.carryover_json.reset_negative_balance ? "Yes" : "No"}</p>
                    </div>
                </div>
            )}

            {/* Fine-Tuning */}
            {formData.fine_tuning_json && (
                <div className="mb-6">
                    <h3 className="text-lg font-medium text-gray-700 border-b pb-2 mb-3">Fine-Tuning</h3>
                    <div className="grid grid-cols-2 gap-4 text-gray-600">
                        <p><strong>Prorating:</strong> {formData.fine_tuning_json.prorating}</p>
                        <p><strong>Timing:</strong> {formData.fine_tuning_json.timing}</p>
                    </div>
                </div>
            )}

            {/* Milestones Section */}
            {formData.milestones_json && Object.keys(formData.milestones_json).length > 0 && (
                <div className="mb-6">
                    <h3 className="text-lg font-medium text-gray-700 border-b pb-2 mb-3">Milestones</h3>
                    <div className="grid gap-4">
                        {Object.entries(formData.milestones_json).map(([key, milestone]) => (
                            <div key={key} className="border rounded-lg p-3 bg-gray-50">
                                <p className="text-gray-800 font-semibold">Milestone: {key}</p>
                                <p><strong>Accrual Rate:</strong> {milestone.accrual_rate ?? "N/A"} hrs</p>
                                <p><strong>Cap Hours Limit:</strong> {milestone.cap_hours_limit ?? "N/A"} hrs</p>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default SummaryStep;
